import PageLayout from "@/components/site/PageLayout";
import PageHeader from "@/components/site/PageHeader";
import FAQ, { faqs } from "@/components/site/FAQ";
import CTABand from "@/components/site/CTABand";
import SEO from "@/components/site/SEO";

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FAQPage() {
  return (
    <PageLayout testid="faq-page">
      <SEO
        title="Invisible Grills FAQ — Safety, Warranty & Cost | Sudeeksha"
        description="Common questions about invisible grills in Hyderabad — safety, view, rust resistance, installation time and warranty. Answered by Sudeeksha Invisible Grills."
        path="/faq"
        jsonLd={faqJsonLd}
      />
      <PageHeader
        eyebrow="Good to know"
        title={["Frequently Asked", "Questions"]}
        crumb="FAQ"
        subtitle="Answers to the most common questions about invisible grills — safety, view, rust resistance, installation and warranty."
      />
      <FAQ />
      <CTABand />
    </PageLayout>
  );
}
